"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_player_1 = __importDefault(require("react-player"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var notifier_1 = __importDefault(require("@utils/notifier"));
var _store_1 = require("@store");
var isVideoMetadataSuccess_1 = require("../../utils/isVideoMetadataSuccess");
var mediasSlice_1 = require("../../state/mediasSlice");
function VideoPlayer(props) {
    var isEditModeEnabled = props.isEditModeEnabled, disableVideo = props.disableVideo, fullImageContainerSize = props.fullImageContainerSize, adId = props.adId, showVideoActionIcons = props.showVideoActionIcons, openMediaGalleryModal = props.openMediaGalleryModal, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, isHovered = props.isHovered;
    var dispatch = (0, _store_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var selectedVideoId = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaIdSelector)(state, adId); });
    var selectedVideoMetadata = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.videoMetadataSelector)(state, adId, selectedVideoId); });
    var selectedVideo = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.videoSelector)(state, adId, selectedVideoId); });
    var isPlaying = selectedVideo && (selectedVideo === null || selectedVideo === void 0 ? void 0 : selectedVideo.isPlaying);
    var isDeleted = selectedVideoMetadata && (0, isVideoMetadataSuccess_1.isVideoMetadataSuccess)(selectedVideoMetadata) && selectedVideoMetadata.deleted;
    var videoUrl = selectedVideoMetadata === null || selectedVideoMetadata === void 0 ? void 0 : selectedVideoMetadata.url;
    var videoPlayerRef = (0, react_1.useRef)(null);
    var onError = function (error) {
        if ((typeof error === 'object' && 'type' in error && (error === null || error === void 0 ? void 0 : error.type) !== 'error') ||
            !(typeof error === 'object' && 'type' in error) ||
            typeof error === 'string') {
            notifier_1.default.error(String(error));
        }
    };
    return (react_1.default.createElement("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: "video-player-wrapper" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('main-video', isDeleted && 'is-deleted') },
            showVideoActionIcons && isHovered && (react_1.default.createElement("div", { className: "main-video__action-container" },
                isEditModeEnabled && (react_1.default.createElement("div", { className: (0, clsx_1.default)('media-item-action media-item-action__remove-or-undo eva-tooltip-container', isDeleted ? 'implioicons-revert' : 'implioicons-trash'), onClick: function () {
                        disableVideo && disableVideo(selectedVideoId);
                    } },
                    react_1.default.createElement("span", { className: "eva-tooltip" }, isDeleted ? t('ITEM.IMAGE_GALLERY.UNDO_REFUSE_VIDEO_TOOLTIP') : t('ITEM.IMAGE_GALLERY.REFUSE_VIDEO_TOOLTIP')))),
                openMediaGalleryModal && (react_1.default.createElement("div", { className: "media-item-action eva-tooltip-container implioicons-enlarge", onClick: openMediaGalleryModal },
                    react_1.default.createElement("span", { className: "eva-tooltip" }, t('ITEM.IMAGE_GALLERY.ENLARGE_TOOLTIP')))))),
            react_1.default.createElement(react_player_1.default, { ref: videoPlayerRef, url: videoUrl, playing: isPlaying, width: fullImageContainerSize.width, height: fullImageContainerSize.height, onPlay: function () { return dispatch((0, mediasSlice_1.play)({ adId: adId })); }, onPause: function () { return dispatch((0, mediasSlice_1.pause)({ adId: adId })); }, onError: onError, controls: true }))));
}
exports.default = VideoPlayer;
